import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KudosDto } from '../../../types'
import { KudosIconIndicator } from '../../../modules/kudos/components/KudosIconIndicator'
import BackgroundBox from '../BackgroundBox'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'
import { getKudosColor } from '../../../shared/kudosUtil'
import AttentionPointDetailsModal from '../AttentionPointDetailsModal/AttentionPointDetailsModal'

export interface AttentionPointCardProps {
  attentionPoint: KudosDto
  nameDisplayPreference: string
}

export const AttentionPointCard: FC<AttentionPointCardProps> = ({ attentionPoint, nameDisplayPreference }) => {
  const { t } = useTranslation()

  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <BackgroundBox r>
        <PerFlexRow direction="column" justify="space-between" className="fullHeight">
          <PerFlexRow direction="column">
            <PerFlexRow align="middle" justify="space-between" mb="xs">
              <KudosIconIndicator kudosType={attentionPoint.type} />
              <a
                onClick={(e) => {
                  e.preventDefault()
                  setIsModalOpen(true)
                }}
                style={{
                  fontSize: '12px',
                  color: '#05cbce',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {t('attentionPoint.viewDetails')}
              </a>
            </PerFlexRow>

            <PerText className="ellipsis--line-3">{attentionPoint.description}</PerText>
          </PerFlexRow>

          {attentionPoint.author && (
            <PerFlexRow justify="end" mt="s">
              <PerFlexRow direction="column" align="bottom">
                <PerText fontSize="s" fontWeight="bold" color={getKudosColor(attentionPoint.type)}>
                  {computeFullname(nameDisplayPreference, attentionPoint.author.firstName, attentionPoint.author.lastName)}
                </PerText>
                {attentionPoint.author.companyName && (
                  <PerText fontSize="xs" mt="xxxs" color="secondary">
                    {attentionPoint.author.companyName}
                  </PerText>
                )}
              </PerFlexRow>
            </PerFlexRow>
          )}
        </PerFlexRow>
      </BackgroundBox>

      <AttentionPointDetailsModal visible={isModalOpen} onClose={() => setIsModalOpen(false)} attentionPoint={attentionPoint} />
    </>
  )
}

export default AttentionPointCard
